import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function Impressum() {
  return (
    <>
      <SEO
        title="Impressum – PINE Systems"
        description="Anbieterkennzeichnung und rechtliche Angaben der PINE Gaming GmbH."
        noindex
      />
      <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-12 md:pt-36 md:pb-20">
          <div className="overline">Rechtliches</div>
          <h1 className="font-display text-4xl md:text-6xl uppercase mt-4 max-w-4xl leading-[1.05]">
            <span className="text-[#18E096]">Impressum.</span>
          </h1>
          <p className="text-[#AEB7B7] mt-6 max-w-2xl">
            Angaben gemäß § 5 TMG.
          </p>
        </div>
      </section>

      <section>
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20 space-y-10">
          <div className="surface p-8" data-testid="impressum-company">
            <div className="overline mb-3">Anbieter</div>
            <p className="text-[#AEB7B7] leading-relaxed">
              PINE Systems ist eine Abteilung der
            </p>
            <h2 className="font-display text-2xl md:text-3xl uppercase mt-2 text-white">
              PINE Gaming GmbH
            </h2>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
              <div>
                <div className="overline mb-2">Anschrift</div>
                <div className="flex items-start gap-3 text-[#AEB7B7]">
                  <MapPin size={16} strokeWidth={1.5} className="text-[#18E096] mt-1 shrink-0" />
                  <div className="text-white">
                    Lehfeld 1<br />
                    21029 Hamburg<br />
                    Deutschland
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <div className="overline mb-2">Kontakt</div>
                  <a
                    href="tel:+4915122202892"
                    className="flex items-center gap-3 text-white hover:text-[#18E096] transition-colors"
                    data-testid="impressum-phone"
                  >
                    <Phone size={16} strokeWidth={1.5} /> 0151 22202892
                  </a>
                  <a
                    href="mailto:kontakt@pinegaming.de"
                    className="flex items-center gap-3 text-white hover:text-[#18E096] transition-colors mt-2"
                    data-testid="impressum-email"
                  >
                    <Mail size={16} strokeWidth={1.5} /> kontakt@pinegaming.de
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px border-l border-t border-[rgba(255,255,255,0.08)]">
            <div className="border-r border-b border-[rgba(255,255,255,0.08)] p-7">
              <div className="overline mb-2">Geschäftsführer</div>
              <p className="text-white">Marcel André Gürgen</p>
            </div>
            <div className="border-r border-b border-[rgba(255,255,255,0.08)] p-7">
              <div className="overline mb-2">Handelsregister</div>
              <p className="text-white">Amtsgericht Hamburg, HRB 189347</p>
            </div>
            <div className="border-r border-b border-[rgba(255,255,255,0.08)] p-7">
              <div className="overline mb-2">Umsatzsteuer-ID</div>
              <p className="text-white">DE449906383</p>
            </div>
            <div className="border-r border-b border-[rgba(255,255,255,0.08)] p-7">
              <div className="overline mb-2">Verantwortlich gemäß § 18 MStV</div>
              <p className="text-white">
                Marcel André Gürgen
                <br />
                Lehfeld 1
                <br />
                21029 Hamburg, Deutschland
              </p>
            </div>
          </div>

          <div className="surface p-8">
            <div className="overline mb-3">EU-Streitbeilegung</div>
            <p className="text-[#AEB7B7] leading-relaxed text-sm">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
              bereit, die Sie hier finden:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noreferrer"
                className="text-[#18E096] hover:text-white inline-flex items-center gap-1 break-all"
                data-testid="impressum-odr-link"
              >
                https://ec.europa.eu/consumers/odr/
                <ArrowUpRight size={14} strokeWidth={1.5} />
              </a>
              .
            </p>
            <p className="text-[#AEB7B7] leading-relaxed text-sm mt-3">
              Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.
            </p>
          </div>

          <div className="text-center">
            <Link to="/" className="btn-secondary" data-testid="impressum-back">
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
